module.exports = __webpack_public_path__ + "static/media/ai_skill.10ee1154.svg";